export default __webpack_public_path__ + "static/media/MontserratAlternates-Medium.9da60aa1.ttf";